/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Criteria_UpdatedInputs */

const en_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search criteria updated`)
};

const de_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suchkriterium aktualisiert`)
};

const fr_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Critère de recherche mis à jour`)
};

const es_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criterio de búsqueda actualizado`)
};

const it_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criterio di ricerca aggiornato`)
};

const nl_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zoekcriterium bijgewerkt`)
};

const pl_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kryterium wyszukiwania zaktualizowane`)
};

const fi_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakukriteeri päivitetty`)
};

const da_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Søgekriterium opdateret`)
};

const sv_jobs_criteria_updated = /** @type {(inputs: Jobs_Criteria_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sökkriterium uppdaterat`)
};

/**
* | output |
* | --- |
* | "Search criteria updated" |
*
* @param {Jobs_Criteria_UpdatedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_criteria_updated = /** @type {((inputs?: Jobs_Criteria_UpdatedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Criteria_UpdatedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_criteria_updated(inputs)
	if (locale === "fr") return fr_jobs_criteria_updated(inputs)
	if (locale === "es") return es_jobs_criteria_updated(inputs)
	if (locale === "it") return it_jobs_criteria_updated(inputs)
	if (locale === "nl") return nl_jobs_criteria_updated(inputs)
	if (locale === "pl") return pl_jobs_criteria_updated(inputs)
	if (locale === "fi") return fi_jobs_criteria_updated(inputs)
	if (locale === "da") return da_jobs_criteria_updated(inputs)
	if (locale === "sv") return sv_jobs_criteria_updated(inputs)
	return en_jobs_criteria_updated(inputs)
});